import styled from 'styled-components'

export const Wrapper = styled.div`
  align-items: center;
  :hover {
    cursor: pointer;
  }
`
